/**
 * Created by Sergey Panpurin on 11/11/2018.
 */

// @ts-check
(function btBigBrainBankAuthServiceClosure() {
  'use strict';

  angular.module('ecapp').factory('btBigBrainBankAuthService', btBigBrainBankAuthService);

  btBigBrainBankAuthService.$inject = ['$q', '$http', 'btSettings', 'btErrorService'];

  /**
   * This service collect logic connected to BigBrainBank integration.
   *
   * @ngdoc service
   * @name btBigBrainBankAuthService
   * @memberOf ecapp
   * @param {angular.IQService} $q - promise interface
   * @param {angular.IHttpService} $http
   * @param {ecapp.ISettings} btSettings
   * @param {ecapp.IErrorService} btErrorService
   * @return {ecapp.IBigBrainBankAuthService}
   */
  function btBigBrainBankAuthService($q, $http, btSettings, btErrorService) {
    console.log('Running btBigBrainBankAuthService');

    return {
      register: register,
    };

    /**
     * This function registers new BigBrainBank user in bettertrader system.
     *
     * @param {string} email - email of new BigBrainBank user
     * @param {object} details - BigBrainBank user details
     * @return {angular.IPromise<boolean>}
     */
    function register(email, details) {
      var params = {};
      return $http
        .post(btSettings.BT_BACKEND_URL + '/v1/bigbrainbank/users', { email: email, details: details }, params)
        .then(function (response) {
          console.log('btShareScopeService:', response);
          return true;
        })
        .catch(btErrorService.handleHTTPError);
    }
  }
})();
